import { Instagram } from "lucide-react";
import LuminartLogo from "./LuminartLogo";
import { INSTAGRAM_URL } from "../campaigns";
import { useSiteText } from "../lib/content";

export const Footer = () => {
  const t = useSiteText();
  const EMAIL = t("footer_email", "contact@luminartprojection.com");

  return (
    <footer
      data-testid="site-footer"
      className="bg-[#050505] px-6 md:px-12 lg:px-16 pt-12 pb-8"
    >
      <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
        <div className="flex items-center gap-3">
          <LuminartLogo className="w-9 h-auto" glow={false} />
          <span className="font-heading text-sm tracking-[0.35em] uppercase text-white/80">
            Luminart
          </span>
        </div>

        <div className="flex items-center gap-8 text-[10px] uppercase tracking-[0.25em] text-white/40">
          <a
            href={`mailto:${EMAIL}`}
            data-testid="footer-email-link"
            className="hover:text-white transition-colors"
          >
            {EMAIL}
          </a>
          <span>London, UK</span>
        </div>

        <div className="flex items-center gap-6">
          <a
            href={INSTAGRAM_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-instagram-link"
            className="inline-flex items-center gap-2 text-[10px] uppercase tracking-[0.25em] text-white/40 hover:text-white transition-colors"
          >
            <Instagram size={14} strokeWidth={1.5} /> Instagram
          </a>
          <button
            data-testid="footer-back-to-top"
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            className="text-[10px] uppercase tracking-[0.25em] text-white/40 hover:text-white transition-colors"
          >
            Back to top ↑
          </button>
        </div>
      </div>
      <p className="mt-10 text-right text-[10px] uppercase tracking-[0.2em] text-white/25">
        © {new Date().getFullYear()} Luminart Projection. All rights reserved.
      </p>
    </footer>
  );
};

export default Footer;
